import {Field, reduxForm, SubmissionError} from 'redux-form';
import PropTypes from 'prop-types';
import {Button, Divider, Form, Message, Segment} from 'semantic-ui-react';
import FormInput from '../shared/forms/input';
import {mobile, required} from '../shared/forms';

function MobileForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;

  async function submit({mobile}) {
    try {
      await props.onSubmit(mobile);
    } catch (error) {
      if (error.status === 403) {
        const errorMessage = error.data.detail || 'محدودیت ارسال کد تایید شما به پایان رسیده است،';
        props.onError(errorMessage);
      } else {
        let DEFAULT_ERROR_MESSAGE = 'کاربری با این شماره تلفن همراه در پنل مدمشاور یافت نشد.';
        const errorMessage = error.message || DEFAULT_ERROR_MESSAGE;
        throw new SubmissionError({_error: errorMessage});
      }
    }
  }

  return (
    <Segment>
      <Divider horizontal content='فرم فراموشی رمز عبور'/>
      <div className='text-medium my-4'>
        شماره تلفن همراه وارد شده هنگام ثبت نام را وارد کنید:
      </div>

      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null))}>
          <Field
            required
            inline
            name='mobile'
            label='شماره تلفن همراه'
            type='tel'
            placeholder='09121234567'
            fluid={false}
            component={FormInput}
            validate={[required, mobile]}
          />

        <Button
          basic
          positive
          type='submit'
          disabled={pristine || submitting}
          content='ادامه'
        />
      </Form>
    </Segment>
  );
}

MobileForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

export default reduxForm({form: 'mobile'})(MobileForm);
